import { Form, Input } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'

interface CommentProps {}

const Comment: FC<CommentProps> = () => {
    const ctx = useContext(EditableCellCtx)

    // const options = [
    //     // {
    //     //     value: 'new',
    //     //     // label: (
    //     //     //     <>
    //     //         <PlusOutlined />
    //     //     //     </>
    //     //     // ),
    //     //     label: 'Создать новую',
    //     // },
    //     {
    //         value: '1',
    //         label: 'Ночной охотник, Курица, Кусочки мяса в сырно-сметанном соусе',
    //     },
    //     {
    //         value: '2',
    //         label: 'Ночной охотник, Кролик, Кусочки мяса в сметанном соусе',
    //     },
    //     {
    //         value: '3',
    //         label: 'Амурр, Кролик в желе',
    //     },
    //     {
    //         value: '4',
    //         label: 'Амурр, Ягненок в соусе',
    //     },
    //     {
    //         value: '5',
    //         label: 'Амурр, Мясное ассорти в соусе',
    //     },
    //     {
    //         value: '6',
    //         label: 'Амурр, Курица соусе',
    //     },
    //     {
    //         value: '7',
    //         label: 'Амурр, Ягненок в желе',
    //     },
    //     {
    //         value: '8',
    //         label: 'Амурр, Утка с морковью в желе',
    //     },
    // ]

    return (
        <Form.Item name={'comment'} noStyle>
            <Input autoFocus onBlur={ctx.onBlur} />
            {/* <Select
                // style={{ maxWidth: 200 }}
                style={{ width: '100%' }}
                options={options}
                popupMatchSelectWidth={400}
                showSearch
                filterOption={filterOptionByLabel}
                autoFocus
                onBlur={ctx.onBlur}
                defaultOpen
            /> */}
        </Form.Item>
    )
}

export default Comment
